export enum ResultsViewType {
    MINI,
    ROW,
    FULL
}
